import React from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import cn from 'classnames';
import moment from 'moment';
// this is not used directly, but has to be included
// noinspection ES6UnusedImports
import momentDurationFormatSetup from 'moment-duration-format'; // eslint-disable-line no-unused-vars
import { bindActionCreators } from 'redux';

import fetchSalon from 'actions/fetchSalon.action';
import beFetchStylistStripeDashboard from 'actions/stylist/beFetchStylistStripeDashboard.action';
import beSetupStylistStripeAccount from 'actions/stylist/beSetupStylistStripeAccount.action';
import fetchStylistsBySalon from 'actions/stylist/fetchStylistsBySalon.action';
import { feBusinessStripeFoldToggle, feStripeFoldToggle, feTipsFoldToggle } from 'actions/ui.actions';
import ICO_TIPS from 'assets/images/icons/currency-pound-black.svg';
import ICO_BOOKING from 'assets/images/icons/general-settings.svg';
import ICO_PAYMENT from 'assets/images/icons/pay-black.svg';
import ICO_DESCRIPTION from 'assets/images/icons/pencil-note.svg';
import ICO_SETTINGS from 'assets/images/online-booking/General-purple.svg';
import ICO_HOURS from 'assets/images/online-booking/Hours.svg';
import IMG_AVATAR from 'assets/images/online-booking/no-image.png';
import ICO_SERVICES from 'assets/images/online-booking/Services.svg';
import ToggleFeature from 'components/core/ToggleFeature.component';
import Button from 'components/form/Button.component';
import Badge from 'components/generic/Badge.component';
import ExternalLink from 'components/generic/ExternalLink.component';
import Foldout from 'components/generic/Foldout.component';
import Icon from 'components/generic/Icon.component';
import Space from 'components/generic/Space.component';
import Tooltip from 'components/generic/Tooltip.component';
import StripeStatusBadges from 'components/settings/StripeStatusBadges.component';
import PUSHER from 'config/pusher.singleton';
import DELAY from 'constants/delay.const';
import LINK from 'constants/link.const';
import TRANSFER_POLICY from 'constants/pos/stripeTransferPolicy.const';
import STRIPE_STATUS from 'constants/stripeStatus.const';
import { withTranslation } from 'providers/GILT.provider';
import { withTheme } from 'providers/Theme.provider';
import {
  selectCurrentSalonBetaAnnualSalon,
  selectCurrentSalonBilling,
  selectCurrentSalonId,
  selectCurrentSalonNoShowProtection,
  selectCurrentSalonStripeAccount,
  selectCurrentSalonStylists,
} from 'selectors/currentSalon.selectors';
import { selectBookingStripeAccountStatus } from 'selectors/settings.selectors';
import {
  selectBusinessStripeFoldoutOpen,
  selectStripeFoldoutOpen,
  selectTipsFoldoutOpen,
} from 'selectors/ui.selectors';
import noNilArray from 'utils/arrays/noNilArray.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import fromObjectToKeys from 'utils/converters/object/fromObjectToKeys.util';
import { formatHourAndMinuteShortMeridiem } from 'utils/date/format.util';
import isTouchDevice from 'utils/dom/isTouchDevice.util';
import { locationReplace } from 'utils/dom/location.util';
import pageScrollToTop from 'utils/dom/pageScrollToTop.util';
import delayed from 'utils/functions/delayed.util';
import linkTo from 'utils/links/linkTo.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import createNodeKey from 'utils/react/createNodeKey.util';
import C from 'utils/values/constant.util';

import PopupModalContainer from 'common/PopupModal';
import { SALON_STRIPE_SETUP } from 'lib/constants/currentSalon';
import { putService } from 'onboarding/services/actions';
import {
  clearCompletedSaveSalon,
  fetchSalonState,
  getCategories,
  removeFBIntegration,
  toggleOnlineBoarding,
} from 'salon/actions';
import beGetSettingsNcob from 'settings/actions/beGetSettingsNcob';
import {
  changeIsOnline,
  changeIsOpen,
  changePatchTest,
  clearCompletedSaveSettings,
  clearErrorMessage,
  getSalonOnlineSettings,
  getSalonOnStripeDashboard,
  restoreServerData,
  saveSalonOnlineSettings,
  setSalonNoshowOrDeposit,
  stylistCategoryChangeIsOnline,
  toggleEverythingOffline,
} from 'settings/online-booking/actions';
import ModalSetupOnlineBooking from 'settings/online-booking/modals/ModalSetupOnlineBooking';
import SetupSelfEmployedModal from 'settings/online-booking/modals/SetupSelfEmployedModal';
import StripeSetupNoticeModal from 'settings/online-booking/modals/StripeSetupNoticeModal.component';
import StaffTips from 'settings/online-booking/pages/settings/StaffTips.component';
import PieChart from 'settings/online-booking/PieChart.component';
import BookingCode from 'settings/page-elements/booking-code/BookingCode';
import ConfirmationModal from 'settings/page-elements/ConfirmationModal';
import DropdownPatchTest from 'settings/page-elements/dropdown/DropdownPatchTest';
import DropdownService from 'settings/page-elements/dropdown/DropdownService';
import DropdownNoSwitcher from 'settings/page-elements/dropdown/DropdownServiceWithoutSwitcher';
import FacebookConnect from 'settings/page-elements/FacebookConnect';
import DepositSetup from 'settings/page-elements/setup-nsp-deposit/DepositSetup';
import StripeModal from 'settings/page-elements/setup-nsp-deposit/modals/StripeModal';
import NoShowProtectionSetup from 'settings/page-elements/setup-nsp-deposit/NoShowProtectionSetup';
import RequestDepositSetup from 'settings/page-elements/setup-nsp-deposit/RequestDepositSetup';
import ServicesDescription from 'settings/services/ServicesDescription.component';

import NoBillingModal from './modals/NoBillingModal';

import CN from './SetUpView.module.scss';

const L = logger('SetUpView');

const ONE_STYLIST = 1;

const DISPLAY_BUTTON = false;
const USE_POLICY_SECTION = false;
const RENDER_ERROR_MODAL = false;

const LINK_POLICY = 'https://gettingslick.typeform.com/to/Qzbj8C#company_name=xxxxx';

// NOTE: we send numbers to the BE, but it returns strings that we need to map to these values
const TRANSFER_POLICY_MAP = C({
  NO_TRANSFERS: TRANSFER_POLICY.noTransfers,
  SELF_EMPLOYED_ALL_TRANSFERS: TRANSFER_POLICY.allTransfers, // 20
  SELF_EMPLOYED_SPLIT_COMMISSIONS: TRANSFER_POLICY.splitCommissions, // 30
  EMPLOYED_TIP_ONLY: TRANSFER_POLICY.tipOnly, // 40
});

const getShortDay = (fullName) => {
  const name = fullName.split(' ')[0];
  switch (name) {
    case 'Monday': {
      return 'common.days.mon';
    }
    case 'Tuesday': {
      return 'common.days.tue';
    }
    case 'Wednesday': {
      return 'common.days.wed';
    }
    case 'Thursday': {
      return 'common.days.thu';
    }
    case 'Friday': {
      return 'common.days.fri';
    }
    case 'Saturday': {
      return 'common.days.sat';
    }
    case 'Sunday': {
      return 'common.days.sun';
    }
    default:
      return '';
  }
};

const getFullDayName = (shortName) => {
  switch (shortName) {
    case 'mon': {
      return 'common.days.monday';
    }
    case 'tue': {
      return 'common.days.tuesday';
    }
    case 'wed': {
      return 'common.days.wednesday';
    }
    case 'thu': {
      return 'common.days.thursday';
    }
    case 'fri': {
      return 'common.days.friday';
    }
    case 'sat': {
      return 'common.days.saturday';
    }
    case 'sun': {
      return 'common.days.sunday';
    }
    default:
      return '';
  }
};

class SetUpView extends React.Component {
  static generateDates(props) {
    // if index start with 0, checkboxes in patch test has same id as in business hours
    // clicking on patch test items with check/uncheck days, so start from 200
    let index = 200;
    const duration = moment.duration();
    const dayItems = [];
    const keys = Object.keys(props.settingsData.business_hours);
    let dayCount = 0;

    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      const day = props.settingsData.business_hours[key];
      if (day) {
        const a = moment.utc(day.open_hr, 'hh:mm:ss');
        const b = moment.utc(day.close_hr, 'hh:mm:ss');
        if (day.is_open) {
          dayCount += 1;
          duration.add(b.diff(a));
        }

        const formattedA = formatHourAndMinuteShortMeridiem(a);
        const formattedB = formatHourAndMinuteShortMeridiem(b);

        dayItems.push({
          id: (index += 1),
          name: `${props.t(getFullDayName(key))} ${formattedA} - ${formattedB}`,
          is_open: day.is_open,
        });
      }
    }

    return { duration, dayItems, dayCount };
  }

  static countOnlineServices(props) {
    let shouldBreak = false;
    let servicesCount = 0;
    const stylistIds = Object.keys(props.settingsData.stylist_service_data);
    for (let i = 0; i < stylistIds.length; i += 1) {
      if (shouldBreak) {
        break;
      }
      const stylist = props.settingsData.stylist_service_data[stylistIds[i]];
      const categoryIds = stylist.categories ? Object.keys(stylist.categories) : [];
      for (let j = 0; j < categoryIds.length; j += 1) {
        if (shouldBreak) {
          break;
        }
        const category = stylist.categories[categoryIds[j]];
        for (let k = 0; k < category.length; k += 1) {
          if (shouldBreak) {
            break;
          }
          if (category[k].is_online) {
            servicesCount += 1;
            if (servicesCount >= 1) {
              shouldBreak = true;
            }
          }
        }
      }
    }
    return servicesCount;
  }

  constructor(props) {
    super(props);
    const data = SetUpView.generateDates(props);

    this.state = {
      dayCount: data.dayCount,
      dayItems: data.dayItems,
      confirmDaysOfflineModal: false,
      confirmOnlineModal: false,
      renderStripeSetupNoticeModal: false,
      lastDay: '',
      confirmServicesOfflineModal: false,
      no_show_protection: props.no_show_protection,
      confirmCategoryModal: false,
      isSalonOnline: props.currentSalon.online_booking,
      popupMessage: '',
      hasChanged: false,
      confirmOfflineModal: false,
      componentFirstMounted: false,
      hasOnlineService: false,
      hasOpenDay: false,
      changedCategories: [],
      checkedNSP: true,
      errorEnableModal: false,
      enableMessage: '',
      displayLoadingFast: false,
      displayLoadingSlow: false,
      timerFast: null,
      timerSlow: null,
      showBillingPop: false,
      descriptionChanged: false,
      hasStripe: false,
      isSetupSelfEmployedRendered: false,
      selectedStylistId: null,
      isHiddenMap: {},
    };

    this.parentContainerRef = React.createRef();
    this.childContainerRef = React.createRef();
  }

  UNSAFE_componentWillMount() {
    pageScrollToTop();
    const { settingStarted, areSettingsSaved, getSalonOnlineSettings, getCategories, salonId } = this.props;
    if (!settingStarted || areSettingsSaved) {
      setTimeout(() => {
        L.unignore('componentWillMount()', 'getSalonOnlineSettings:', getSalonOnlineSettings(salonId));
        L.unignore('componentWillMount()', 'getCategories:', getCategories(salonId));
      }, 100);
    }
  }

  async componentDidMount() {
    this.fetchSettingsNcob();

    const { salonId, fetchStylistsBySalon } = this.props;
    delayed(DELAY.autohide, () => void this.updateContainerLengths());

    window.addEventListener('resize', this.updateContainerLengths);

    fetchStylistsBySalon(salonId);
    this.subscribe();

    // initialize all stylists in the state and add them to isHiddenMap with an initial value true
    // to avoid an otherwise necessary double-click when opening the details for each stylist
    const { stylists } = this.props;
    const stylistsEditMap = {};
    for (const stylist of noNilArray(stylists)) {
      stylistsEditMap[stylist.id] = true;
    }
    this.setState({ isHiddenMap: stylistsEditMap });

    window.addEventListener('beforeunload', (event) => {
      event.preventDefault();
    });

    L.debug('SetUpView', 'componentDidMount()', this.props.errorMessage);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.settingsData !== nextProps.settingsData || this.state.hasChanged) {
      if (!this.state.componentFirstMounted) {
        this.setState({ componentFirstMounted: true });
      }
      const data = SetUpView.generateDates(nextProps);
      let hasOpenDay = false;
      if (data.dayCount > 0) {
        hasOpenDay = true;
      }
      let hasOnlineService = false;
      if (SetUpView.countOnlineServices(nextProps) > 0) {
        hasOnlineService = true;
      }
      this.setState({
        dayCount: data.dayCount,
        dayItems: data.dayItems,
        hasOpenDay,
        hasOnlineService,
        stripeModal: false,
        isSalonOnline: data.dayCount > 0 && hasOnlineService && nextProps.settingsData.online_booking,
      });
    }
  }

  componentDidUpdate() {
    clearTimeout(this.state.timerFast);
    clearTimeout(this.state.timerSlow);
  }
  componentWillUnmount() {
    const { getSalonOnlineSettings, salonId } = this.props;
    window.removeEventListener('resize', this.updateContainerLengths);

    this.unsubscribe();
    clearTimeout(this.state.timerFast);
    clearTimeout(this.state.timerSlow);
    L.unignore('componentWillUnmount()', 'getSalonOnlineSettings:', getSalonOnlineSettings(salonId));
  }

  onNoShowCheckboxClick = () => {
    if (this.props.ncob_deposit_settings !== 'null') {
      const enableMessage = this.props.t('onlineBooking.generalSettings.enableMessage1');
      this.setState({ errorEnableModal: true, enableMessage });
    } else if (this.props.ncob_deposit_settings === 'null') {
      const data = {
        ncob_deposit_settings: this.props.ncob_deposit_settings,
        ncob_custom_amount: this.props.ncob_custom_amount,
        no_show_protection: !this.props.no_show_protection,
      };
      this.props.SetSalonNoshowOrDeposit(data, this.props.salonId.toString());
      this.setState({ no_show_protection: !this.state.no_show_protection });
    }
  };

  onDepositCheckboxClick = () => {
    if (this.props.no_show_protection) {
      const enableMessage = this.props.t('onlineBooking.generalSettings.enableMessage2');
      this.setState({ errorEnableModal: true, enableMessage });
    }
    if (this.props.ncob_deposit_settings === 'null' && !this.props.no_show_protection) {
      const data = {
        ncob_deposit_settings: this.props.ncob_deposit_settings,
        ncob_custom_amount: this.props.ncob_custom_amount,
        no_show_protection: this.props.no_show_protection,
      };
      this.props.SetSalonNoshowOrDeposit(data, this.props.salonId.toString());
    } else if (this.props.ncob_deposit_settings !== 'null' && !this.props.no_show_protection) {
      const data = {
        ncob_deposit_settings: 'null',
        ncob_custom_amount: 0,
        no_show_protection: this.state.no_show_protection,
      };
      this.props.SetSalonNoshowOrDeposit(data, this.props.salonId.toString());
    }
  };

  onStylistServiceCheckboxClick = (stylistId, serviceId, value) => {
    let servicesCount = 0;
    let shouldBreak = false;
    const stylistIds = Object.keys(this.props.settingsData.stylist_service_data);

    for (let i = 0; i < stylistIds.length; i += 1) {
      if (shouldBreak) {
        break;
      }
      const stylist = this.props.settingsData.stylist_service_data[stylistIds[i]];
      const categoryIds = Object.keys(stylist.categories);
      for (let j = 0; j < categoryIds.length; j += 1) {
        if (shouldBreak) {
          break;
        }
        const category = stylist.categories[categoryIds[j]];
        for (let k = 0; k < category.length; k += 1) {
          if (shouldBreak) {
            break;
          }
          if (category[k].is_online) {
            servicesCount += 1;
            if (servicesCount > 1) {
              shouldBreak = true;
            }
          }
        }
      }
    }

    if (!value && servicesCount === 1) {
      this.setState(
        {
          hasChanged: true,
          confirmServicesOfflineModal: true,
          popupMessage: this.props.t('onlineBooking.generalSettings.confirmationModal.popupMessage1'),
        },
        this.checkButton(),
      );
    } else {
      this.props.changeIsOnline(stylistId, serviceId, value);
      this.setState({ hasChanged: true, hasOnlineService: true }, () => {
        this.checkButton();
      });
    }
  };

  onDayCheckboxClick = (name, id, value) => {
    const dayName = this.props.t(getShortDay(name));
    const days = Object.keys(this.props.settingsData.business_hours);
    let openCount = 0;
    let shouldSet = true;

    for (let i = 0; i < days.length; i += 1) {
      const day = this.props.settingsData.business_hours[days[i]];
      if (day && day.is_open) {
        openCount += 1;
      }
    }

    if (!value && openCount === 1) {
      shouldSet = false;
      const popupMessage = this.props.t('onlineBooking.generalSettings.confirmationModal.popupMessage2');
      this.setState({ confirmDaysOfflineModal: true, lastDay: dayName, popupMessage });
    } else if (value && this.state.hasOnlineService) {
      this.setState({ isSalonOnline: true, hasChanged: true, hasOpenDay: true });
    }

    if (shouldSet) {
      this.props.changeIsOpen(dayName, value);
      this.setState({ hasChanged: true }, () => {
        this.checkButton();
      });
    }
  };

  onPatchTestCheckboxClick = (name, id, value, isSwitcher) => {
    this.props.changePatchTest(id, value);
    this.setState({ hasChanged: true }, () => {
      if ((isSwitcher && isSwitcher[0] === isSwitcher[1]) || !isSwitcher) {
        this.checkButton();
      }
    });
  };

  onSalonCheckBoxClick = () => {
    if (this.state.isSalonOnline) {
      const popupMessage = <div>{this.props.t('onlineBooking.generalSettings.confirmationModal.popupMessage3')}</div>;
      this.setState({ confirmOfflineModal: true, popupMessage });
    }
    if (!this.props.has_completed_online_boarding) {
      this.setState({ confirmOnlineModal: true });
    } else {
      this.confirmOnlineSalon();
    }
  };

  setupStripeAccount = async (stylistId, transferPolicy = null) => {
    const FTAG = 'setupStripeAccount()';

    const { beSetupStylistStripeAccount, hasStripeAccount, salonId, getSalonOnlineSettings } = this.props;

    if (!hasStripeAccount) {
      L.debug(FTAG, 'Aborting setup because hasStripeAccount:', hasStripeAccount);
      return;
    }

    this.setState({ stripeModal: true, isSetupSelfEmployedRendered: false, renderStripeSetupNoticeModal: false });
    // if the status is incomplete we do not send the transferPolicy parameter
    const requestData = { stylistId, transferPolicy: transferPolicy ?? void 1 };
    const result = await beSetupStylistStripeAccount(requestData);

    // browser might garbage collect objects, but strings remain in the console longer
    L.debug(FTAG, 'result text:', result?.text);

    this.setState({ stripeModal: false });

    if (!result.is.ok) return;
    await getSalonOnlineSettings(salonId); // update UI

    const url = fromAnyToString(result?.json?.stripe_link);
    L.info(FTAG, 'Navigating to', url, '...');
    locationReplace({ url });
  };

  viewStripeDashboard = async (stylistId) => {
    const { beFetchStylistStripeDashboard } = this.props;
    const isTouch = isTouchDevice();

    this.setState({ stripeModal: true });

    const result = await beFetchStylistStripeDashboard({ stylistId });

    if (result.is.ok) {
      this.setState({ stripeModal: false });

      if (isTouch) {
        const newWindow = window.open(result.json.url, '_blank', 'noopener,noreferrer');
        if (newWindow) {
          // if possible open new windows and redirect to url
          newWindow.location.href = result.json.url;
        } else {
          window.location.href = result.json.url;
        }
      } else {
        // open in a new window if it's desktop
        window.open(result.json.url, '_blank', 'noopener,noreferrer');
      }
    } else {
      this.setState({ stripeModal: false });
    }
  };

  gotoSalonStripeDashboard = () => {
    if (!this.props.dashboardUrl) {
      this.props.getSalonOnStripeDashboard(this.props.salonId);
    }
    const interval = setInterval(() => {
      if (this.props.dashboardUrl) {
        clearInterval(interval);
        window.open(this.props.dashboardUrl, '_blank', 'noopener noreferrer');
      }
    }, 500);
  };

  fetchSettingsNcob = async () => {
    const { beGetSettingsNcob } = this.props;
    try {
      const result = await beGetSettingsNcob();

      if (result.is.ok) {
        const hasStripe = result.json.has_ncob_stripe_account;
        this.setState({ hasStripe });
      }
    } catch (error) {
      this.setState({ hasStripe: this.state.hasStripe });
      L.debug('fetchSettingsNcob()', 'error:', error);
    }
  };

  gotoBilling = () => {
    const oldpath = this.props.history.location.pathname;
    const newPath = `${oldpath.split('onlinebooking')[0]}settings/billing`;
    this.props.history.push({ pathname: newPath });
  };

  subscribe = () =>
    void PUSHER.redux.subscribe({
      channelName: `${this.props.salonId}_channel`,
      eventName: 'salon_stripe_setup',
      actionType: SALON_STRIPE_SETUP,
    });

  unsubscribe = () => {
    PUSHER.redux.unsubscribe({
      channelName: `${this.props.salonId}_channel`,
      eventName: 'salon_stripe_setup',
      actionType: SALON_STRIPE_SETUP,
    });
  };

  // setup no-show and deposit
  closeErrorModal = () => {
    this.setState({ errorEnableModal: false, enableMessage: '' });
  };

  compareSettings = (oldSettings, newSettings) => {
    // services
    const stylistIds = Object.keys(oldSettings.stylist_service_data);
    const changedCategories = [];

    for (let i = 0; i < stylistIds.length; i += 1) {
      const oldStylist = oldSettings.stylist_service_data[stylistIds[i]];
      const newStylist = newSettings.stylist_service_data[stylistIds[i]];
      const oldCategoryIds = Object.keys(oldStylist.categories);
      const newCategoryIds = Object.keys(newStylist.categories);
      const categoryIdsToUse = oldCategoryIds.length > newCategoryIds.length ? oldCategoryIds : newCategoryIds;
      for (let j = 0; j < categoryIdsToUse.length; j += 1) {
        const oldCategory = oldStylist.categories[categoryIdsToUse[j]];
        const newCategory = newStylist.categories[categoryIdsToUse[j]];
        for (let k = 0; k < oldCategory.length; k += 1) {
          if (!oldCategory[k]) {
            changedCategories.push(categoryIdsToUse[j], stylistIds[i]);
            break;
          }
          if (!newCategory[k]) {
            changedCategories.push(categoryIdsToUse[j], stylistIds[i]);
            break;
          }
          if (oldCategory[k].is_online !== newCategory[k].is_online) {
            changedCategories.push(categoryIdsToUse[j], stylistIds[i]);
          }
        }
      }
    }
    // days
    const oldDays = Object.keys(oldSettings.business_hours);
    const newDays = Object.keys(newSettings.business_hours);

    const daysToUse = oldDays.length >= newDays.length ? oldDays : newDays;
    for (let i = 0; i < daysToUse.length; i += 1) {
      const oldDay = oldSettings.business_hours[oldDays[i]];
      const newDay = newSettings.business_hours[oldDays[i]];
      if (oldDay && newDay) {
        if (oldDay.is_open !== newDay.is_open) {
          break;
        }
      }
    }

    this.setState({ changedCategories });
  };

  stylistCategoryChangeIsOnline = (stylistId, categoryName, value) => {
    let categoriesCount = 0;
    const stylistIds = Object.keys(this.props.settingsData.stylist_service_data);

    for (let i = 0; i < stylistIds.length; i += 1) {
      const stylist = this.props.settingsData.stylist_service_data[stylistIds[i]];
      const categoryIds = Object.keys(stylist.categories);
      for (let j = 0; j < categoryIds.length; j += 1) {
        const category = stylist.categories[categoryIds[j]];
        for (let k = 0; k < category.length; k += 1) {
          if (category[k].is_online) {
            categoriesCount += 1;
            break;
          }
        }
      }
    }

    if (!value && categoriesCount === 1) {
      this.setState(
        {
          confirmCategoryModal: true,
          hasChanged: true,
          popupMessage: this.props.t('onlineBooking.generalSettings.confirmationModal.popupMessage1'),
        },
        this.checkButton(),
      );
    } else {
      this.props.stylistCategoryChangeIsOnline(stylistId, categoryName, value);
      this.setState({ hasChanged: true, hasOnlineService: true }, () => {
        this.checkButton();
      });
    }
  };

  hideConfirmDaysModal = () => {
    this.setState({ confirmDaysOfflineModal: false, lastDay: '', popupMessage: '' });
  };

  confirmOfflineDays = () => {
    if (this.state.lastDay) {
      this.props.changeIsOpen(this.state.lastDay, false);
    }
    this.props.toggleEverythingOffline(false, 'day');

    this.setState({
      confirmDaysOfflineModal: false,
      lastDay: '',
      popupMessage: '',
      isSalonOnline: false,
      hasChanged: true,
      hasOpenDay: false,
    });
    setTimeout(() => {
      this.setState({ isSalonOnline: false }, this.saveChanges(false));
      this.setState({ confirmOfflineModal: false, popupMessage: '' });
    }, 1);
  };

  checkButton = () => {
    let activeService;
    let activeDay;

    activeDay = false;
    const days = Object.keys(this.props.settingsData.business_hours);
    for (let i = 0; i < days.length; i += 1) {
      const day = this.props.settingsData.business_hours[days[i]];
      if (day && day.is_open) {
        activeDay = true;
        break;
      }
    }
    activeService = false;
    const stylistIds = Object.keys(this.props.settingsData.stylist_service_data);
    for (let i = 0; i < stylistIds.length; i += 1) {
      if (activeService) {
        break;
      }
      const stylist = this.props.settingsData.stylist_service_data[stylistIds[i]];
      const categoryNames = Object.keys(stylist.categories);
      for (let j = 0; j < categoryNames.length; j += 1) {
        if (activeService) {
          break;
        }
        const category = stylist.categories[categoryNames[j]];
        for (let k = 0; k < category.length; k += 1) {
          if (category[k].is_online) {
            activeService = true;
            break;
          }
        }
      }
    }
    if (activeDay && activeService) {
      if (!this.props.currentSalon.has_completed_online_boarding) {
        this.props.toggleOnlineBoarding();
      }
    }
    if (this.state.hasChanged) {
      if (activeDay && activeService) {
        setTimeout(() => {
          this.setState({ isSalonOnline: true }, this.saveChanges(true));
        }, 1);
      } else if (!activeDay) {
        this.props.toggleEverythingOffline(false, 'day');
        setTimeout(() => {
          this.setState({ isSalonOnline: false }, this.saveChanges(false));
        }, 1);
      } else if (!activeService) {
        this.props.toggleEverythingOffline(false, 'service');
        setTimeout(() => {
          this.setState({ isSalonOnline: false }, this.saveChanges(false));
        }, 1);
      }
    }
  };

  hideConfirmOfflineModal = () => {
    this.setState({ confirmOfflineModal: false, popupMessage: '' }, () => {});
  };

  hideConfirmOnlineModal = () => {
    this.setState({ confirmOnlineModal: false, popupMessage: '' }, () => {});
  };

  refreshStylistData = () => {
    const { salonId, getSalonOnlineSettings } = this.props;
    L.unignore('refreshStylistData()', 'getSalonOnlineSettings:', getSalonOnlineSettings(salonId));
  };

  confirmOfflineSalon = () => {
    // give sometime for the above function to finish before saving
    setTimeout(() => {
      this.setState({ isSalonOnline: false }, this.saveChanges(false));
      this.setState({ confirmOfflineModal: false, popupMessage: '' });
    }, 1);
  };

  confirmOnlineSalon = () => {
    if (this.props.has_billing || this.props.beta_annual_salon) {
      setTimeout(() => {
        this.setState({ isSalonOnline: true }, this.saveChanges(true));
        this.setState({ confirmOnlineModal: false, popupMessage: '' });
      }, 1);
    } else {
      this.setState({ showBillingPop: true, confirmOnlineModal: false });
    }
  };

  hideConfirmServicesModal = () => {
    this.setState({
      confirmServicesOfflineModal: false,
      popupMessage: '',
    });
  };

  hideConfirmCategoryModal = () => {
    this.setState({
      confirmCategoryModal: false,
      popupMessage: '',
    });
  };

  hideShowBillingPop = () => {
    this.setState({
      showBillingPop: false,
    });
  };

  showSelfEmployedModal = (stylistId) => {
    const accountStatus = this.props.stripeAccountStatus?.[stylistId]?.stripe_account_status;
    if (accountStatus !== STRIPE_STATUS.incomplete && accountStatus !== STRIPE_STATUS.restricted) {
      this.setState({
        isSetupSelfEmployedRendered: true,
        selectedStylistId: stylistId,
        renderStripeSetupNoticeModal: false,
      });
    } else {
      // If the status is incomplete, we call setupStripeAccount without a modal
      this.setupStripeAccount(stylistId);
    }
  };
  confirmOfflineServices = () => {
    this.props.toggleEverythingOffline(false, 'service');
    this.setState({
      confirmServicesOfflineModal: false,
      popupMessage: '',
      isSalonOnline: false,
      hasOnlineService: false,
    });
    setTimeout(() => {
      this.setState({ isSalonOnline: false }, this.saveChanges(false));
      this.setState({ confirmOfflineModal: false, popupMessage: '' });
    }, 1);
  };

  confirmOfflineCategory = () => {
    this.props.toggleEverythingOffline(false, 'service');
    this.setState({
      confirmCategoryModal: false,
      popupMessage: '',
      hasChanged: true,
      isSalonOnline: false,
      hasOnlineService: false,
    });
    setTimeout(() => {
      this.setState({ isSalonOnline: false }, this.saveChanges(false));
      this.setState({ confirmOfflineModal: false, popupMessage: '' });
    }, 1);
  };

  saveChanges = (tf) => {
    if (!this.props.currentSalon.has_completed_online_boarding) {
      this.props.toggleOnlineBoarding();
    }
    this.props.saveSalonOnlineSettings(this.props.salonId, this.props.settingsData, this.props.initialServerData, tf);
    // when saveSalonOnlineSettings, props.isFetching is set to true
    // it will be set to false when api call returned
    // when we know it's saved, we call fetchSalon to update online_booking setting
    if (!this.props.initialServerData.online_booking && this.props.settingsData.online_booking) {
      this.asyncCall();
    }
  };

  resolveAfterSaved = () =>
    new Promise((resolve) => {
      const interval = setInterval(() => {
        if (!this.props.isFetching) {
          resolve('resolved');
          this.props.fetchSalon(this.props.salonId);
          clearInterval(interval);
        }
      }, 200);
    });

  asyncCall = async () => void (await this.resolveAfterSaved());

  hideSuccessMessage = () => {
    this.props.clearCompletedSaveSalon();
    this.props.clearCompletedSaveSettings();
  };

  updateContainerLengths = () => {
    const parentContainer = this.parentContainerRef.current;
    const childContainer = this.childContainerRef.current;

    if (parentContainer && childContainer) {
      const parentContainerLength = parentContainer.offsetWidth;
      const childContainerLength = childContainer.offsetWidth;

      this.setState({
        parentContainerLength,
        childContainerLength,
      });
    }
  };

  toggleAlertModal = () => void this.setState({ isAlertModalOpen: !this.state.isAlertModalOpen });
  handleCloseSetupOnlineBooking = () => void this.setState({ confirmOnlineModal: false });

  onToggleStylistDetails = (stylistId) => {
    this.setState((prevState) => ({
      isHiddenMap: {
        ...prevState.isHiddenMap,
        [stylistId]: !prevState.isHiddenMap[stylistId],
      },
    }));
  };

  handleOpenStripeNoticeModal = (stylistId) => {
    this.setState({
      renderStripeSetupNoticeModal: true,
      selectedStylistId: stylistId,
    });
    L.debug('SetUpView', 'handleOpenStripeNoticeModal()', 'stylist ID', stylistId);
  };

  render() {
    const {
      salonId,
      hasBilling,
      hasStripeAccount,
      stylists,
      isDarkMode,
      hasBetaAnnualSalon,
      feStripeFoldToggle,
      feBusinessStripeFoldToggle,
      feTipsFoldToggle,
      isBusinessStripeFoldoutOpen,
      isStripeFoldoutOpen,
      isTipsFoldoutOpen,
      hasNoShowProtection,
      t,
    } = this.props;
    const {
      childContainerLength,
      parentContainerLength,
      isAlertModalOpen,
      isSetupSelfEmployedRendered,
      renderStripeSetupNoticeModal,
      selectedStylistId,
      confirmOnlineModal,
      popupMessage,
      errorEnableModal,
    } = this.state;

    const isOneStylist = stylists.filter((s) => s.has_column && s.status !== 'deleted' && !s.serves_as_waitlist).length;
    const businessHoursArray = Object.entries(this.props.settingsData.business_hours);

    const HEADER_SETTINGS = (
      <div className={CN.flex}>
        <div className={CN.settingsTitle}>{t('onlineBooking.generalSettings.socialWebsiteLinks.foldoutTitle')}</div>
        <Badge
          variant={this.state.isSalonOnline ? 'success' : 'draft'}
          disabled={!this.state.isSalonOnline}
          height="sm"
        >
          <div className={CN.gapSmall}>
            {this.state.isSalonOnline
              ? t('onlineBooking.generalSettings.online')
              : t('onlineBooking.generalSettings.offline')}
          </div>
        </Badge>
      </div>
    );

    const HEADER_HOURS = (
      <div className={CN.flex}>
        <div className={CN.space}>{t('onlineBooking.generalSettings.businessOnlineHours.foldoutTitle')} </div>
        <div className={CN.daysContainer}>
          {businessHoursArray.map(([day, { is_open: isOpen }]) => (
            <div
              key={day}
              className={cn({
                [CN.day]: true,
                [CN.active]: isOpen,
              })}
            >
              {t(getFullDayName(day)).charAt(0)}
            </div>
          ))}
        </div>
      </div>
    );

    const STYLIST_DATA = Object.keys(this.props.settingsData.stylist_service_data);
    const isAllStylistVisible = childContainerLength > parentContainerLength;

    const renderedTitle = (
      <div className={CN.stylistWrap}>
        <div className={CN.staffTitle}>{t('onlineBooking.generalSettings.staffOnlineServices.foldoutTitle')}</div>
        <div className={CN.parentContainer} ref={this.parentContainerRef}>
          <div
            ref={this.childContainerRef}
            className={cn({
              [CN.childContainer]: true,
            })}
          >
            {STYLIST_DATA.map((stylistId, index) => {
              const stylist = this.props.settingsData.stylist_service_data[stylistId];

              const name = fromAnyToTrimmed(asObject(stylist).name);
              const shortName = stylist.name.substring(0, 2);

              let activeServices = 0;

              const keys = stylist.categories ? Object.keys(stylist.categories) : [];

              for (let j = 0; j < keys.length; j += 1) {
                const categoryId = keys[j];
                const services = stylist.categories[categoryId];

                for (let i = 0; i < services.length; i += 1) {
                  if (services[i].is_online) {
                    activeServices += 1;
                  }
                }
              }
              const renderedTooltipStylistName = (
                <div>
                  <div className={CN.cutText}> {name}</div>
                  {t('onlineBooking.generalSettings.staffOnlineServices.is')}
                  {activeServices === 0
                    ? t('onlineBooking.generalSettings.online')
                    : t('onlineBooking.generalSettings.offline')}
                </div>
              );

              return (
                <div
                  key={createNodeKey({ index, name })}
                  className={cn({
                    [CN.circle]: true,
                    [CN.isOff]: activeServices === 0,
                  })}
                >
                  <Tooltip variant="right" width="s2" content={renderedTooltipStylistName}>
                    <div className={CN.tooltipText}>{shortName}</div>
                  </Tooltip>
                </div>
              );
            })}
          </div>
        </div>
        {isAllStylistVisible && (
          <div className={CN.countLabel}>{t('onlineBooking.generalSettings.staffOnlineServices.countLabel')}</div>
        )}
      </div>
    );

    const componentClasses = cn({
      [CN.component]: true,
      [CN.darkMode]: isDarkMode,
    });

    const transferPolicy =
      TRANSFER_POLICY_MAP[this.props.stripeAccountStatus[selectedStylistId]?.transfer_policy] || null;

    const stylistStripeStatus = this.props.stripeAccountStatus[selectedStylistId]?.stripe_account_status;
    const isSetupIncomplete = selectedStylistId?.stripe_account_status === STRIPE_STATUS.incomplete;

    return (
      <div data-bem="SetupView--online-booking" className={componentClasses}>
        <ModalSetupOnlineBooking
          isOpen={confirmOnlineModal && !this.props.has_completed_online_boarding}
          onClose={this.handleCloseSetupOnlineBooking}
          onClick={this.handleCloseSetupOnlineBooking}
        />

        <SetupSelfEmployedModal
          stylistId={selectedStylistId}
          isOpen={isSetupSelfEmployedRendered}
          transferPolicy={transferPolicy}
          onClose={() => void this.setState({ isSetupSelfEmployedRendered: false })}
          onClick={(transferPolicy) => this.setupStripeAccount(selectedStylistId, transferPolicy)}
          determineSetupButtons={stylistStripeStatus}
        />

        {this.state.confirmDaysOfflineModal && (
          <ConfirmationModal
            popupTitle={t('onlineBooking.generalSettings.confirmationModal.title')}
            popupMessage={popupMessage}
            btnConfirmName={t('onlineBooking.generalSettings.confirmationModal.confirmButton')}
            btnDiscardName={t('onlineBooking.generalSettings.confirmationModal.discardButton')}
            discard={this.hideConfirmDaysModal}
            confirm={this.confirmOfflineDays}
            closeModal={this.hideConfirmDaysModal}
          />
        )}

        {this.state.confirmServicesOfflineModal && (
          <ConfirmationModal
            popupTitle={t('onlineBooking.generalSettings.confirmationModal.title')}
            popupMessage={popupMessage}
            btnConfirmName={t('onlineBooking.generalSettings.confirmationModal.confirmButton')}
            btnDiscardName={t('onlineBooking.generalSettings.confirmationModal.discardButton')}
            discard={this.hideConfirmServicesModal}
            confirm={this.confirmOfflineServices}
            closeModal={this.hideConfirmServicesModal}
          />
        )}

        {this.state.confirmCategoryModal && (
          <ConfirmationModal
            popupTitle={t('onlineBooking.generalSettings.confirmationModal.title')}
            popupMessage={popupMessage}
            btnConfirmName={t('onlineBooking.generalSettings.confirmationModal.confirmButton')}
            btnDiscardName={t('onlineBooking.generalSettings.confirmationModal.discardButton')}
            discard={this.hideConfirmCategoryModal}
            confirm={this.confirmOfflineCategory}
            closeModal={this.hideConfirmCategoryModal}
          />
        )}

        {this.state.confirmOfflineModal && (
          <ConfirmationModal
            popupTitle={t('onlineBooking.generalSettings.confirmationModal.title')}
            popupMessage={popupMessage}
            btnConfirmName={t('onlineBooking.generalSettings.confirmationModal.confirmButton')}
            btnDiscardName={t('onlineBooking.generalSettings.confirmationModal.discardButton')}
            discard={this.hideConfirmOfflineModal}
            confirm={this.confirmOfflineSalon}
            closeModal={this.hideConfirmOfflineModal}
          />
        )}

        {this.props.errorMessage && RENDER_ERROR_MODAL && (
          <PopupModalContainer
            popupTitle={t('onlineBooking.generalSettings.errorModal.title1')}
            popupMessage={this.props.errorMessage}
            buttonText={t('onlineBooking.generalSettings.errorModal.confirmButton')}
            buttonCallback={this.props.clearErrorMessage}
          />
        )}

        <NoBillingModal isOpen={isAlertModalOpen || this.state.showBillingPop} onClose={this.toggleAlertModal} />

        <StripeSetupNoticeModal
          isOpen={renderStripeSetupNoticeModal}
          onClose={() => this.setState({ renderStripeSetupNoticeModal: false })}
          buttonText={
            isSetupIncomplete
              ? t('onlineBooking.generalSettings.completeSetup')
              : t('onlineBooking.generalSettings.setupStripe')
          }
          onClick={
            isSetupIncomplete
              ? () => this.setupStripeAccount(selectedStylistId)
              : () => this.showSelfEmployedModal(selectedStylistId)
          }
        />

        {errorEnableModal && (
          <PopupModalContainer
            popupTitle={t('onlineBooking.generalSettings.errorModal.title1')}
            popupMessage={this.state.enableMessage}
            buttonText={t('onlineBooking.generalSettings.errorModal.confirmButton')}
            buttonCallback={this.closeErrorModal}
          />
        )}

        {/* Business Stripe Account & Deposits */}
        <div data-bem="SetUpView__business-stripe--foldout" className={CN.foldoutContainer}>
          <div className={CN.foldoutHeader} role="button" onClick={feBusinessStripeFoldToggle}>
            <div className={CN.foldoutTitle}>
              <img src={ICO_PAYMENT} alt="" className={CN.foldoutIcon} />
              <div className={CN.title}>
                {t('onlineBooking.generalSettings.businessStripeAccount.foldoutTitle')}
                <StripeStatusBadges tag="SetUpView" />
              </div>
            </div>

            <Icon
              tag="SetUpView__arrow"
              variant="arrowFoldout"
              selected={!isBusinessStripeFoldoutOpen}
              unselected={isBusinessStripeFoldoutOpen}
              width="l1"
            />
          </div>

          {isBusinessStripeFoldoutOpen && (
            <>
              <RequestDepositSetup
                random_key={this.props.random_key}
                isFetchingRandomKey={this.props.isFetchingRandomKey}
                gotoSalonStripeDashboard={this.gotoSalonStripeDashboard}
                fetchSalonState={this.props.fetchSalonState}
              />

              {hasNoShowProtection && (
                <NoShowProtectionSetup
                  onNoShowCheckboxClick={this.onNoShowCheckboxClick}
                  checkedNSP={this.state.checkedNSP}
                  random_key={this.props.random_key}
                  isFetchingRandomKey={this.props.isFetchingRandomKey}
                  email={this.props.email}
                  SetSalonNoshowOrDeposit={this.props.SetSalonNoshowOrDeposit}
                  salonId={salonId}
                  errorEnableModal={errorEnableModal}
                  has_ncob_stripe_accoun={hasStripeAccount}
                  fetchSalonState={this.props.fetchSalonState}
                />
              )}

              <DepositSetup
                onDepositCheckboxClick={this.onDepositCheckboxClick}
                has_ncob_stripe_account={hasStripeAccount}
                ncob_custom_amount={this.props.ncob_custom_amount}
                random_key={this.props.random_key}
                isFetchingRandomKey={this.props.isFetchingRandomKey}
                email={this.props.email}
                SetSalonNoshowOrDeposit={this.props.SetSalonNoshowOrDeposit}
                salonId={salonId}
                no_show_protection={this.props.no_show_protection}
                ncob_deposit_settings={this.props.ncob_deposit_settings}
                errorEnableModal={errorEnableModal}
                has_ncob_stripe_accoun={hasStripeAccount}
                fetchSalonState={this.props.fetchSalonState}
              />
            </>
          )}
        </div>

        {/* Tips */}
        <div data-bem="SetUpView__tips--foldout" className={CN.foldoutContainer}>
          <div className={CN.foldoutHeader} role="button" onClick={feTipsFoldToggle}>
            <div className={CN.foldoutTitle}>
              <img src={ICO_TIPS} alt="" className={CN.foldoutIcon} />
              {t('onlineBooking.generalSettings.tips.foldoutTitle')}
            </div>

            <Icon
              tag="SetUpView__arrow"
              variant="arrowFoldout"
              selected={!isTipsFoldoutOpen}
              unselected={isTipsFoldoutOpen}
              width="l1"
            />
          </div>

          {isTipsFoldoutOpen && (
            <div className={CN.foldoutContent}>
              <StaffTips />
            </div>
          )}
        </div>

        {/* Staff Stripe Accounts & Online Services */}
        <div data-bem="SetUpView__stylist-foldout" className={CN.foldoutContainer}>
          <div className={CN.foldoutHeader} role="button" onClick={feStripeFoldToggle}>
            <div className={CN.foldoutTitle}>
              <img src={ICO_SERVICES} alt="" className={CN.foldoutIcon} />
              {renderedTitle}
            </div>

            <Icon
              tag="SetUpView__arrow"
              variant="arrowFoldout"
              selected={!isStripeFoldoutOpen}
              unselected={isStripeFoldoutOpen}
              width="l1"
            />
          </div>

          {isStripeFoldoutOpen && (
            <div className={CN.foldoutContent}>
              <div>
                {DISPLAY_BUTTON && (
                  <Button variant="emphasis" onClick={this.refreshStylistData}>
                    {t('onlineBooking.generalSettings.staffOnlineServices.refreshData')}
                  </Button>
                )}
              </div>

              <div className={CN.subTitle}></div>

              <div data-bem="SetUpView__table-header" className={CN.dropdownHeader}>
                <div className={CN.mobileHeader}>
                  {t('onlineBooking.generalSettings.staffOnlineServices.tableHeaders.onlineBooking')}
                </div>
                <div className={CN.colName}>
                  {t('onlineBooking.generalSettings.staffOnlineServices.tableHeaders.staffMember')}
                </div>
                <div className={CN.colService}>
                  {t('onlineBooking.generalSettings.staffOnlineServices.tableHeaders.bookableServices')}
                </div>
                <div className={CN.colButton}>
                  {t('onlineBooking.generalSettings.staffOnlineServices.tableHeaders.stripAccount')}
                </div>
                <div className={CN.colTips}>
                  {t('onlineBooking.generalSettings.staffOnlineServices.tableHeaders.takings')}
                </div>
              </div>

              {Object.keys(this.props.settingsData.stylist_service_data).map((stylistId) => {
                const stylist = this.props.settingsData.stylist_service_data[stylistId];
                const transferPolicy = stylist?.transfer_policy || null;

                const name =
                  fromAnyToTrimmed(stylist?.name) || t('onlineBooking.generalSettings.staffOnlineServices.name');
                const isSelf =
                  stylist && stylist.is_self_employed
                    ? t('onlineBooking.generalSettings.staffOnlineServices.selfEmployed')
                    : t('onlineBooking.generalSettings.staffOnlineServices.employed');
                const BUTTON_NAME =
                  stylist.stripe_account_status === STRIPE_STATUS.incomplete
                    ? t('onlineBooking.generalSettings.completeSetup')
                    : t('onlineBooking.generalSettings.setupStripe');

                let role = 'Stylist';
                if (stylist.role && stylist.role.trim()) {
                  ({ role } = stylist);
                }

                let activeServices = 0;
                let allServices = 0;

                const keys = fromObjectToKeys(stylist?.categories ?? {});

                for (let j = 0; j < keys.length; j += 1) {
                  const categoryId = keys[j];
                  const services = stylist.categories[categoryId];

                  for (let i = 0; i < services.length; i += 1) {
                    if (services[i]) {
                      allServices += 1;
                    }
                    if (services[i].is_online) {
                      activeServices += 1;
                    }
                  }
                }

                return (
                  <div key={stylistId}>
                    <DropdownService
                      stylistFace={IMG_AVATAR}
                      generalName={name}
                      isSelf={isSelf}
                      className={CN.item}
                      subName={role}
                      serviceCount={<PieChart activeServices={activeServices} allServices={allServices} />}
                      stripeStatus={stylist.stripe_account_status}
                      category_services={this.props.settingsData.category_services}
                      stylist={stylist}
                      singleCompleted={STYLIST_DATA.length === 1 && hasStripeAccount}
                      stylistId={parseInt(stylistId, 10)}
                      disabled={!this.state.isSalonOnline}
                      onCheckboxClick={
                        !hasBilling && !hasBetaAnnualSalon ? this.toggleAlertModal : this.onStylistServiceCheckboxClick
                      }
                      onSwitcherClick={
                        !hasBilling && !hasBetaAnnualSalon ? this.toggleAlertModal : this.stylistCategoryChangeIsOnline
                      }
                      onToggle={() => this.onToggleStylistDetails(stylistId)}
                      isEditMode={this.state.isHiddenMap[stylistId] ?? true}
                      changedCategories={this.state.changedCategories}
                      descriptionChanged={this.state.descriptionChanged}
                      isOff={activeServices === 0}
                      isOneStylist={isOneStylist === ONE_STYLIST}
                      onEditTransferPolicy={() =>
                        this.setState({ isSetupSelfEmployedRendered: true, selectedStylistId: stylistId })
                      }
                      transferPolicy={transferPolicy}
                    >
                      {isOneStylist > ONE_STYLIST && (
                        <div>
                          {fromAnyToBool(stylist.stripe_account) ? (
                            <Button variant="stripped" onClick={() => this.viewStripeDashboard(stylistId)}>
                              <div className={CN.colorButton}>
                                {t('onlineBooking.generalSettings.staffOnlineServices.stripeLogin')}
                              </div>
                            </Button>
                          ) : (
                            <div>
                              {hasStripeAccount ? (
                                <Button variant="outline" onClick={() => this.handleOpenStripeNoticeModal(stylistId)}>
                                  <div className={CN.buttonSpace}>{BUTTON_NAME}</div>
                                </Button>
                              ) : (
                                <Tooltip
                                  variant="topLeft"
                                  content={t('onlineBooking.generalSettings.staffOnlineServices.tooltip')}
                                >
                                  <Button variant="primary" disabled={!hasStripeAccount}>
                                    <div className={CN.buttonSpace}>
                                      {t('onlineBooking.generalSettings.staffOnlineServices.stripeLogin')}
                                    </div>
                                  </Button>
                                </Tooltip>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </DropdownService>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Days Bookable Online */}
        <Foldout isOpen={false} title={HEADER_HOURS} src={ICO_HOURS}>
          <div className="business-hours">
            <DropdownNoSwitcher
              isOffline={!this.state.isSalonOnline || this.state.dayCount === 0}
              subName=""
              parentItems={[
                {
                  id: 1,
                  name: t('onlineBooking.generalSettings.businessOnlineHours.daysAndHours'),
                  days: this.state.dayItems,
                },
              ]}
              parentNamePropName=""
              childItemsPropName="days"
              childItemCheckPropName="is_open"
              disabled={false}
              onCheckboxClick={!hasBilling && !hasBetaAnnualSalon ? this.toggleAlertModal : this.onDayCheckboxClick}
            />
            <div className={CN.infoLink}>
              {t('onlineBooking.generalSettings.businessOnlineHours.guide')}
              <NavLink
                to={linkTo({ pattern: LINK.salonHours, params: { salonId }, fault: '#' })}
                activeClassName="active"
                className={CN.item}
                onClick={this.closeMenu}
              >
                <Space> {t('onlineBooking.generalSettings.businessOnlineHours.linkLabel')} </Space>
              </NavLink>
            </div>
          </div>
        </Foldout>

        {/* Booking Link & Social Integrations */}
        <Foldout isOpen={false} title={HEADER_SETTINGS} src={ICO_BOOKING}>
          <BookingCode
            isChecked={this.state.isSalonOnline}
            statusOffline="on"
            salonName={this.props.currentSalon.name}
            salonGroupName={this.props.currentSalon.group_name}
            url={this.props.ncob_tiny_url}
            group_ncob_tiny_url={this.props.group_ncob_tiny_url}
            onCheckboxClick={
              hasBetaAnnualSalon || (!hasBetaAnnualSalon && hasBilling)
                ? this.onSalonCheckBoxClick
                : this.toggleAlertModal
            }
          />
          <ToggleFeature flag="fbConnect">
            <FacebookConnect
              salonId={salonId.toString()}
              salonName={this.props.currentSalon.name}
              removeFBIntegration={this.props.removeFBIntegration}
              url={this.props.ncob_tiny_url}
              group_ncob_tiny_url={this.props.group_ncob_tiny_url}
              fb_details={this.props.currentSalon.fb_details}
            />
          </ToggleFeature>
        </Foldout>

        {/* Service Descriptions */}
        <Foldout
          isOpen={false}
          title={t('onlineBooking.generalSettings.serviceDescription.foldoutTitle')}
          src={ICO_DESCRIPTION}
        >
          <ServicesDescription />
        </Foldout>

        {/* Services Requiring a Patch Test */}
        <DropdownPatchTest
          category_services={this.props.settingsData.category_services}
          subName={t('onlineBooking.generalSettings.patchTestDropdown.subName')}
          isOffline={!this.state.isSalonOnline || this.state.dayCount === 0}
          parentItems={this.props.settingsData.category_services}
          parentNamePropName={t('onlineBooking.generalSettings.patchTestDropdown.patchTest')}
          childItemsPropName="services"
          childItemCheckPropName="patch_test"
          disabled={!this.state.hasOpenDay}
          onCheckboxClick={!hasBilling && !hasBetaAnnualSalon ? this.toggleAlertModal : this.onPatchTestCheckboxClick}
        />
        {this.state.stripeModal ? (
          <StripeModal>
            <div className={CN.textStripeModal}>
              {t('onlineBooking.generalSettings.businessStripeAccount.stripeModalText')}
            </div>
          </StripeModal>
        ) : null}

        {USE_POLICY_SECTION && (
          <Foldout
            isOpen={false}
            title={t('onlineBooking.generalSettings.cancellationPolicy.foldoutTitle')}
            src={ICO_SETTINGS}
          >
            <div data-bem="SetUpView__cancellation-policy" className={CN.container}>
              <div>
                <div className={CN.title}>{t('onlineBooking.generalSettings.cancellationPolicy.title')}</div>
                <div className={CN.text}>{this.props.salon_ncob_text}</div>
                <div className={CN.negativeGap}>
                  <ExternalLink link={LINK_POLICY} variant="secondary">
                    <small>{t('onlineBooking.generalSettings.cancellationPolicy.linkLabel')}</small>
                  </ExternalLink>
                </div>
              </div>
            </div>
          </Foldout>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  hasNoShowProtection: selectCurrentSalonNoShowProtection(state),
  isBusinessStripeFoldoutOpen: selectBusinessStripeFoldoutOpen(state),
  isStripeFoldoutOpen: selectStripeFoldoutOpen(state),
  isTipsFoldoutOpen: selectTipsFoldoutOpen(state),
  stripeAccountStatus: selectBookingStripeAccountStatus(state),
  hasBetaAnnualSalon: selectCurrentSalonBetaAnnualSalon(state),
  hasStripeAccount: selectCurrentSalonStripeAccount(state),
  hasBilling: selectCurrentSalonBilling(state),
  salonId: selectCurrentSalonId(state),
  stylists: selectCurrentSalonStylists(state),
  settingsData: state.settings.onlineBooking.settingsData,
  salon_ncob_text: state.currentSalon.salon_ncob_text,
  ncob_tiny_url: state.currentSalon.ncob_tiny_url || state.settings.onlineBooking.settingsData.ncob_tiny_url,
  ncob_deposit_settings: state.currentSalon.ncob_deposit_settings,
  ncob_custom_amount: state.currentSalon.ncob_custom_amount,
  no_show_protection: state.currentSalon.no_show_protection,
  random_key: state.currentSalon.random_key,
  has_completed_online_boarding: state.currentSalon.has_completed_online_boarding,
  beta_annual_salon: state.currentSalon.beta_annual_salon,
  has_billing: state.currentSalon.has_billing,
  initialServerData: state.settings.onlineBooking.initialServerData,
  isFetching: state.settings.onlineBooking.isFetching,
  isFetchingRandomKey: state.currentSalon.isFetchingRandomKey,
  errorMessage: state.settings.onlineBooking.errorMessage,
  currentSalon: state.currentSalon,
  isSalonSaved: state.currentSalon.isSalonSaved,
  areSettingsSaved: state.settings.onlineBooking.areSettingsSaved,
  settingStarted: state.settings.onlineBooking.settingStarted,
  online_booking: state.currentSalon.online_booking,
  dashboardUrl: state.settings.onlineBooking.dashboardUrl,
  stylistList: state.currentSalon.stylistList.response,
  email: state.settings.billing.stripCusstomerData ? state.settings.billing.stripCusstomerData.email : '',
  services: state.salon.services,
  group_ncob_tiny_url: state.currentSalon.group_ncob_tiny_url,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSalonOnlineSettings,
      beFetchStylistStripeDashboard,
      beSetupStylistStripeAccount,
      saveSalonOnlineSettings,
      clearErrorMessage,
      changeIsOpen,
      changePatchTest,
      changeIsOnline,
      stylistCategoryChangeIsOnline,
      toggleOnlineBoarding,
      toggleEverythingOffline,
      restoreServerData,
      clearCompletedSaveSalon,
      clearCompletedSaveSettings,
      fetchSalon,
      SetSalonNoshowOrDeposit: setSalonNoshowOrDeposit,
      fetchSalonState,
      getSalonOnStripeDashboard,
      putService,
      getCategories,
      removeFBIntegration,
      fetchStylistsBySalon,
      beGetSettingsNcob,
      feStripeFoldToggle,
      feBusinessStripeFoldToggle,
      feTipsFoldToggle,
    },
    dispatch,
  );

const SetUpViewHoc = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withTheme()(SetUpView))),
);

export default SetUpViewHoc;
